export default __webpack_public_path__ + "static/media/137asset_1.354b3159.png";